import { EmptyArray } from "../domain/empty/model";
import { BuyRepositoryImplementation } from '../infrastructure/buy-repository-implementation';


import { cacheManager } from '../infrastructure/cache-manager';

const repo = new BuyRepositoryImplementation();
const CACHE_PREFIX = 'buys';

async function createBuy(payload: any) {
    const response = await repo.createBuy("", "", payload).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

async function createBuyWithSupportDocument(payload: any) {
    const response = await repo.createBuyWithSupportDocument("", "", payload).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

async function getAllBuys(uid: string, cid: string | null, page: number, limit: number) {
    const cacheKey = `${CACHE_PREFIX}-list-${uid}-${cid}-${page}-${limit}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) {
        console.log(`Returning all buys for ${uid}/${cid} from cache`);
        return cached;
    }

    const response = await repo.getAllBuys(uid, cid, page, limit).toPromise();
    let payload = response.data;

    // Normalize response: if it's an array, wrap it in a pagination-like object
    if (Array.isArray(payload)) {
        payload = {
            data: payload,
            total: payload.length,
            page: page,
            page_size: limit
        };
    }

    if (!payload.data || payload.data.length === 0) {
        payload.data = EmptyArray;
    }

    cacheManager.setItem(cacheKey, payload);
    return payload;
}

async function getBuyById(uid: string, cid: string | null, id: string) {
    const cacheKey = `${CACHE_PREFIX}-detail-${id}`;
    const cached = cacheManager.getItem(cacheKey);
    if (cached) {
        console.log(`Returning buy with ID ${id} for ${uid}/${cid} from cache`);
        return cached;
    }

    const response = await repo.getBuyById(uid, cid, id).toPromise();
    const data = response.data;
    if (data.length === 0) return EmptyArray;

    cacheManager.setItem(cacheKey, data);
    return data;
}

async function deleteBuy(uid: string, cid: string | null, id: string) {
    const response = await repo.delete(uid, cid, id).toPromise();
    cacheManager.invalidate(CACHE_PREFIX);
    return response.data;
}

export { createBuy, createBuyWithSupportDocument, getAllBuys, getBuyById, deleteBuy };
